import React, { PropsWithChildren } from "react";
import { Tabs as RMCTabs, PropsType, Models as rmctabsModels } from "rmc-tabs";
import "./styles.scss";

function Tabs(props: PropsWithChildren<PropsType>) {
  return <RMCTabs tabBarBackgroundColor="inherit" prerenderingSiblingsNumber={0} destroyInactiveTab {...props} />;
}

export type TabData = rmctabsModels.TabData;
export default Tabs;
